<template>
  <div class="allocine-rating">
    <div
      ref="ratingBackground"
      class="rating-background" />
    <div class="full-bar" />
  </div>
</template>

<script>
export default {
  name: 'AllocineRating',
  props: {
    rate: {
      type: Number,
      required: true
    }
  },
  watch: {
    rate (rate) {
      this.setValue(rate)
    }
  },
  mounted () {
    this.setValue(this.rate)
  },
  methods: {
    setValue (rate) {
      if (rate >= 0 && rate <= 5) {
        this.$refs.ratingBackground.style.width = ((rate / 5) * 100) + '%'
      } else {
        this.$refs.ratingBackground.style.width = '0%'
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .allocine-rating {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    margin: 0;
    width: calc(18px * 5);
    height: 18px;

    .full-bar,
    .rating-background {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background-repeat: repeat-x;
    }

    .full-bar {
      width: 100%;
      @include mediaQueries('background-image', (xsmall: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18px' height='18px' viewBox='0 0 22 22'><path fill='%23949494' d='M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z'/></svg>"), large: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18px' height='18px' viewBox='0 0 22 22'><path fill='white' d='M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z'/></svg>")));
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18px' height='18px' viewBox='0 0 22 22'><path fill='white' d='M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z'/></svg>");
    }

    .rating-background {
      z-index: 1;
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18px' height='18px' viewBox='0 0 22 22'><path fill='%23FF7900' d='M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z'/></svg>");
    }
  }
</style>
